package com.rosario.juridico.models

import kotlinx.serialization.Serializable

@Serializable
data class UserProfile(
    val uid: String = "",
    val email: String = "",
    val premium: Boolean = false,
    val plan: String = "free",
    val vencimiento: Long = 0L,
    val origenPago: String = "",
    val rol: String = "user",
    val createdAt: Long = 0L,
    val trialEndsAt: Long = 0L,
    val status: String = "trial"
)
